import { postRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

// Function to post a general app image
export const postAppImage = async (path, appImage) => {
  const data = { path, appImage }
  try {
    const { response, logComplete } = await postRequest('appImage', data)
    logger.log('postAppImage response:', response)
    logComplete()
    return response
  } catch (error) {
    logger.error('postAppImage', error)
    throw error
  }
}
